import type { CheckoutProduct } from '../checkoutTracking';

type ProductCarrier = {
  product: { id: string; name: string };
};

/** The distinct products of the purchase, in the order the buyer booked them. */
export const resolveCheckoutProducts = (items: ProductCarrier[] | undefined | null): CheckoutProduct[] => {
  const byId = new Map<string, CheckoutProduct>();

  (items ?? []).forEach(({ product }) => {
    if (product?.id && !byId.has(product.id)) {
      byId.set(product.id, { id: product.id, name: product.name });
    }
  });

  return [...byId.values()];
};

export default resolveCheckoutProducts;
